__turbopack_context__.v({
  "sizeM": "Timestamp-module__fa0CTG__sizeM",
  "sizeS": "Timestamp-module__fa0CTG__sizeS",
  "sizeXS": "Timestamp-module__fa0CTG__sizeXS",
  "sizeXXS": "Timestamp-module__fa0CTG__sizeXXS",
  "timestamp": "Timestamp-module__fa0CTG__timestamp",
  "toneDefault": "Timestamp-module__fa0CTG__toneDefault",
  "toneMuted": "Timestamp-module__fa0CTG__toneMuted",
});
